export default __webpack_public_path__ + "static/media/fellows.3824951b.png";